<template>
  <div class="role-box">
    <!--新增、编辑页面-->
    <role-action
      ref="roleAction"
      v-show="roleInfo.status"
      :type="type"
      :role-info="roleInfo"
      @handlerRoleList="handlerAuthorList"
      @handleClose="closeAction"
    ></role-action>
    <div v-show="!roleInfo.status">
      <!-- 操作栏 -->
      <div class="action-bar">
        <el-input
          size="small"
          clearable
          placeholder="商区码"
          v-model="query.discCode"
          @change="getAuthorList('status')"
          class="param-input"
        />
        <el-input
          size="small"
          clearable
          placeholder="角色名"
          v-model="query.role"
          @change="getAuthorList('status')"
          class="param-input"
        />
        <el-button type="primary" size="small" @click="getAuthorList('status')">搜索</el-button>
        <el-button type="primary" size="small" @click="authorAction('add',roleInfo)">+新增角色</el-button>
      </div>
      <!-- 表格数据 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        @sort-change="handleSortChange"
        ref="multipleTable"
      >
        <!-- <el-table-column prop="id" label="ID" align="center" min-width="140">
          <template slot-scope="scope">
            {{scope.row.id }}
          </template>
        </el-table-column>-->
        <el-table-column prop="discCode" label="商区码" align="center" min-width="140">
          <template slot-scope="scope">{{ scope.row.discCode ? scope.row.discCode : "系统"}}</template>
        </el-table-column>
        <el-table-column prop="role" label="角色名" align="center" min-width="140">
          <template slot-scope="scope">{{scope.row.role }}</template>
        </el-table-column>
        <!-- <el-table-column prop="createdAt" label="创建时间" align="center" min-width="200px">
          <template slot-scope="scope">
            <span>{{scope.row.createdAt | changeDate}}</span>
          </template>
        </el-table-column>-->
        <el-table-column label="操作" align="center" width="200px" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="authorAction('edit',scope.row)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="remove(scope.row.id)"
            ></el-button>
            <!-- <el-button type="warning" size="mini" @click="openDialog(scope.row.id)">发布</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!--分页组件-->
      <el-pagination
        :page-sizes="[10, 15, 20, 30]"
        :current-page="param.pageNumber"
        :page-size="param.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        v-if="total > 10"
        @size-change="changeSize"
        @current-change="changeCurrent"
      ></el-pagination>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <el-radio v-model="radio" label="0">cps子商区</el-radio>
        <el-radio v-model="radio" label="1">cpa子商区</el-radio>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="clone()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import RoleAction from "./components/roleAction";
import API from "@/api";
import { sortEscape } from "@/utils/global";

export default {
  data() {
    return {
      cloneId: "",
      radio: "0",
      dialogVisible: false,
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 通过props传递给子组件的参数
      // 子组件的状态，新增还是修改
      type: "add",
      // 角色的详细信息
      roleInfo: {
        status: false,
        role: "",
        id: "",
        authjson: "[]",
      },
      // 角色管理列表请求参数
      param: {
        pageNumber: 1,
        pageSize: 10,
        discCode: "",
        key: "",
        value: "",
      },
      query: {
        discCode: "系统",
        role: "",
      },
    };
  },
  created() {
    this.getAuthorList();
  },
  components: {
    RoleAction,
  },
  computed: {
    discCode() {
      return this.$store.state.loginModule.userInfo.code;
    },
  },
  methods: {
    /****************************角色列表数据*****************************/
    // 删除author
    remove(id) {
      this.$confirm("您确定要删除当前角色吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteRole({ authID: id, discCode: this.discCode }).then((res) => {
          if (res.code === 200) {
            this.getAuthorList();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else if (res.code === 9200) {
            this.$message.error("该角色已绑定用户,不支持删除!");
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 克隆author
    clone() {
      let params = {
        authID: this.cloneId,
        discType: Number(this.radio),
      };
      API.clone(params).then((res) => {
        if (res.code === 200) {
          this.dialogVisible = false;
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message.error(res.tip || "操作失败");
        }
      });
    },
    // 监听编辑、或者添加成功过后重新拉去数据
    handlerAuthorList() {
      this.param.pageNumber = 1;
      this.getAuthorList();
    },
    // 请求角色管理模块配置列表
    getAuthorList(type) {
      this.loading = true;
      if (type === "status") {
        this.param.pageNumber = 1;
      }
      let param = { ...this.param, ...this.query };
      if (param.discCode === "系统") {
        param.discCode = "";
      }
      param.discCode = param.discCode ? param.discCode : "ZERO_VALUE";
      API.getRoleList(param)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.param.value = sortEscape(column.order);
      this.param.key = column.prop;
      this.getAuthorList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size;
      this.param.pageNumber = 1;
      this.getAuthorList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber;
      this.getAuthorList();
    },
    // 新增、修改角色
    authorAction(type, row) {
      this.type = type;
      this.roleInfo.status = !this.roleInfo.status;
      // this.roleInfo.authjson = row.authJson
      // this.roleInfo.role = row.role
      // this.roleInfo.id = row.id
      this.$refs.roleAction.open(type, row);
    },
    // 关闭修改页面回调函数,清除传递子页面的参数
    closeAction() {
      // 关闭修改页面
      this.roleInfo.status = false;
      // 清空权限数据
      this.roleInfo.authjson = "[]";
      // 清除角色名
      this.roleInfo.role = "";
      // 清除角色id
      this.roleInfo.id = "";
      this.getAuthorList();
    },
    openDialog(id) {
      this.dialogVisible = true;
      this.cloneId = id;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
  },
};
</script>
